import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Loader } from 'belle-js'
import classnames from 'classnames'
import styles from './DocumentList.module.scss'

const DocumentListItemColumn = (props) => {
  const {
    isListHeader,
    header,
    value,
    icon,
    onContentClick,
    className,
  } = props

  const headerClasses = isListHeader ? styles.listColumnHeader : styles.itemColumnHeader
  const classes = classnames(styles.DocumententListItemColumn, className)
  const contentClassName = onContentClick ? styles.itemColumnContentClickable : null
  const contentClasses = classnames(styles.itemColumnContent, contentClassName)

  const renderIcon = () => {
    if (icon === 'loading') {
      const loaderStyle = styles.itemLoader
      return <Loader className={loaderStyle} />
    }
    return (
      <div>
        <Icon data-test-id="document-column-icon" icon={icon} />
      </div>
    )
  }

  return (
    <div className={classes}>
      { header && <div data-test-id="document-column-header" className={headerClasses}>{header}</div> }
      <div className={contentClasses} onClick={onContentClick}>
        { value && <span className={styles.documentName} data-test-id="document-column-value">{value}</span> }
        { icon && renderIcon() }
      </div>
    </div>
  )
}

DocumentListItemColumn.defaultProps = {
  isListHeader: false,
  header: null,
  value: null,
  icon: null,
  onContentClick: null,
  className: '',
}

DocumentListItemColumn.propTypes = {
  isListHeader: PropTypes.bool,
  header: PropTypes.string,
  value: PropTypes.node,
  icon: PropTypes.string,
  onContentClick: PropTypes.func,
  className: PropTypes.string,
}

export default DocumentListItemColumn



// WEBPACK FOOTER //
// ./src/components/Client/DocumentList/DocumentListItemColumn.jsx